define('components/course/collections/levels',[
    'components/course/collections/base',
    'components/course/models/level'
], function (BaseCollection, Level) {
    "use strict";

    return BaseCollection.extend({
        "model": Level
    });
});

